(function () {
    if (window.QLSMobileProductTabsScrollbarLoaded) return;
    window.QLSMobileProductTabsScrollbarLoaded = true;

    function initQLSMobileTabScrollbars() {
      var tablists = document.querySelectorAll('.cc-product-details .tablist');

      tablists.forEach(function (tablist) {
        var scroller = tablist.querySelector('.tablist__scroller');
        if (!scroller) return;

        var track = tablist.querySelector('.qls-tab-scrollbar');
        var thumb;

        if (!track) {
          track = document.createElement('div');
          track.className = 'qls-tab-scrollbar';
          track.setAttribute('aria-hidden', 'true');

          thumb = document.createElement('span');
          thumb.className = 'qls-tab-scrollbar__thumb';

          track.appendChild(thumb);
          tablist.appendChild(track);
        } else {
          thumb = track.querySelector('.qls-tab-scrollbar__thumb');
        }

        if (!thumb) return;

        function updateScrollbar() {
          var maxScroll = scroller.scrollWidth - scroller.clientWidth;

          if (maxScroll <= 2) {
            tablist.classList.remove('qls-tabs-has-overflow');
            return;
          }

          tablist.classList.add('qls-tabs-has-overflow');

          var trackWidth = track.clientWidth || tablist.clientWidth;
          var thumbWidth = Math.max(38, Math.round((scroller.clientWidth / scroller.scrollWidth) * trackWidth));
          var maxThumbMove = Math.max(0, trackWidth - thumbWidth);
          var thumbMove = maxScroll > 0 ? Math.round((scroller.scrollLeft / maxScroll) * maxThumbMove) : 0;

          thumb.style.width = thumbWidth + 'px';
          thumb.style.transform = 'translateX(' + thumbMove + 'px)';
        }

        if (!scroller.__qlsTabScrollbarBound) {
          scroller.addEventListener('scroll', function () {
            window.requestAnimationFrame(updateScrollbar);
          }, { passive: true });

          scroller.__qlsTabScrollbarBound = true;
        }

        window.requestAnimationFrame(updateScrollbar);
        window.setTimeout(updateScrollbar, 100);
        window.setTimeout(updateScrollbar, 600);
      });
    }

    window.addEventListener('resize', initQLSMobileTabScrollbars);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQLSMobileTabScrollbars);
    } else {
      initQLSMobileTabScrollbars();
    }

    document.addEventListener('shopify:section:load', initQLSMobileTabScrollbars);
  })();
